module.exports = __webpack_public_path__ + "static/media/checked.47d3e590.png";